import { connect } from 'react-redux';
import View from './EmptyStateView';
import { setDraftAccount, setViewId } from './AccountsManualStepActions';
import { BASE_ACCOUNT } from '../FinancialAccountsWorkflowConstants';
import { ADD, LINK, OVERVIEW } from './AccountsManualStepViews';
import { bumpProgressBar, jump } from '../../AdvWorkflow/AdvWorkflowActions';
import { canGoBackSelector } from '../../AdvWorkflow/AdvWorkflowSelector';
import {
  hasAccessToLinkAccountsSelector,
  hasPlaidSelector,
  currentClientIdSelector,
} from '../../../CommonSelectors/CommonAreaSelector';
import { fetchDataIfNecessary } from '../../AdvWorkflow/AdvWorkflowCacheActions';

const mapStateToProps = (state, ownProps) => ({
  canGoBack: canGoBackSelector(state, ownProps),
  hasAccessToLinkAccounts: hasAccessToLinkAccountsSelector(state),
  hasPlaid: hasPlaidSelector(state),
  clientId: currentClientIdSelector(state),
});

const mapDispatchToProps = dispatch => ({
  onLinkAccountsPressed: workflowId => event => {
    dispatch(setViewId(LINK, workflowId));
    dispatch(bumpProgressBar(workflowId));
    event.stopPropagation();
  },
  onManualAddAccountPressed: workflowId => event => {
    dispatch(setDraftAccount(BASE_ACCOUNT, workflowId));
    dispatch(setViewId(ADD, workflowId));
    dispatch(bumpProgressBar(workflowId));
    if (event) {
      event.stopPropagation();
    }
  },
  onSkip: workflowId => () => dispatch(jump(1, workflowId)),

  onFinishPlaidWorkflow: async (clientId, workflowId) => {
    await dispatch(
      fetchDataIfNecessary(workflowId, clientId, ['Accounts'], { Accounts: true }, false),
    );
    dispatch(setViewId(OVERVIEW, workflowId));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
